import React, { useState } from "react";
import "reactjs-popup/dist/index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Styles.css";
import "./App.css";

import Map from "./Map";

import TouristData from "./data/Tourist.json";
import PassengerData from "./data/Passenger.json";
import FreightData from "./data/Freight.json";

function App() {
  const [activePage, setActivePage] = useState("map");
  const [selectedScope, setSelectedScope] = useState(TouristData);
  const [selectedScopeName, setSelectedScopeName] = useState("");
  const [highlightId, setHighlightId] = useState("");
  const [scrollToFirstCardHighlight, setScrollToFirstCardHighlight] = useState(false);

  const Pages = {
    map: <Map mapPageCallback={(event) => changeToActivePage(event)} scrollToFirstCardHighlight={scrollToFirstCardHighlight} highlightId={highlightId} data={selectedScope} />,
  };

  const closingScope = (event) => {
    setScrollToFirstCardHighlight(false);
    setActivePage("map");
  };

  const changeToUseCases = (event) => {
    var highlightIdName = event.currentTarget.id;

    setHighlightId(highlightIdName);
    setScrollToFirstCardHighlight(true);
    setActivePage("map");
  };

  const changeToActivePage = (page) => {
    setSelectedScopeName(page.name);

    if (page.name === "About") {
      setSelectedScope(TouristData);
      setScrollToFirstCardHighlight(false);
      setSelectedScopeName("");
      setHighlightId("");
      setActivePage("home");
    } else if (page.name === "x") {
      setScrollToFirstCardHighlight(false);
      setHighlightId("");
      setActivePage("map");
    }
  };

  function PageEnum({ state }) {
    return <div>{Pages[state]}</div>;
  }

  return (
    <div>
      <PageEnum state={activePage}></PageEnum>
    </div>
  );
}

export default App;
